export const flagsmithFeatureFlags = {
  ADD_TO_LIST_FROM_ALERTS: 'add_to_list_from_alerts',
  AGENT_COMMAND_VISIBILITY: 'agent_command_visibility',
  // TODO: rename Flagsmith flag from 'ai_rules_policy' → 'ai_instructions_policy' then align this value
  AI_INSTRUCTIONS_POLICY: 'ai_rules_policy',
  // KIR-3515 AI Instruction Security Policy Catalog (group + Manage-catalog page);
  // KIR-3925 also gates the AI AppSec pages (Threat Modeling + LLM Vulnerability Discovery)
  AI_INSTRUCTION_CATALOG: 'ai_instruction_catalog',
  ALERT_IGNORE: 'alert_ignore',
  ALERTS_IDE_COLUMN: 'alerts_ide_column',
  ALERT_MUTING: 'alert_muting',
  ALERT_NOTIFICATION_SETTINGS: 'alert_notification_settings',
  ALERT_SOURCE_DETAILS: 'alert_source_details',
  ALERTS_REVAMP: 'enable_alerts_revamp',
  BITBUCKET_INTEGRATION: 'bitbucket_integration',
  ENFORCE_POLICY_MODE: 'enforce_policy_mode',
  ENABLE_ORGANIZATION_DASHBOARD: 'enable_dashboard_module',
  ENDPOINT_IDENTIFIER: 'endpoint_identifier',
  EXTENSION_CODE_SCAN: 'extension_code_scan',
  GITHUB_INTEGRATION: 'github_integration',
  HOOK_INVENTORY_ENABLED: 'hook_inventory_enabled',
  HOOK_PREVENTION_MODE: 'hook_prevention_mode',
  HIDE_VSCODE_EXTENSION: 'hide_vscode_extension',
  LINUX_AGENT_RELEASE: 'linux_agent_release',
  // KIR-3746: gates the Settings → API Keys management-key surface (KIR-3748)
  // and the public /api/v1 namespace. Must match the backend
  // `featureFlagKeys.management_api_keys` value.
  MANAGEMENT_API_KEYS: 'management_api_keys',
  PLATFORM_ANTIGRAVITY: 'platform_antigravity',
  PLATFORM_CLAUDE_DESKTOP: 'platform_claude_desktop',
  PLATFORM_CODEX: 'platform_codex',
  PLATFORM_GEMINI_CLI: 'platform_gemini_cli',
  PLATFORM_WINDSURF: 'platform_windsurf',
  PROJECTS_INVENTORY: 'projects_inventory',
  SECRET_CONFIDENCE_THRESHOLD: 'secret_confidence_threshold',
  // KIR-3800: gates the Security Groups pages and the Policies scope selector.
  // Must match the backend `featureFlagKeys.security_groups_policies` value —
  // the same flag gates the group-scoped policy APIs this UI calls.
  SECURITY_GROUPS_POLICIES: 'security_groups_policies',
  SECRET_DETECTION_DETAILS: 'secret_detection_details',
  SHADOW_AI_NETWORK_DISCOVERY: 'shadow_ai_network_discovery',
  AI_MCP_TOOL_ANALYSIS: 'ai_mcp_tool_analysis',
  AGENTMESH_RISK_ESTIMATE: 'agentmesh_risk_estimate',
  CAPABILITY_DETECTION: 'capability_detection',
  MCP_TOOL_RESPONSE_SCANNING: 'mcp_tool_response_scanning',
  SHADOW_AI: 'shadow_ai',
  SHADOW_AI_LOGGED_IN_USER: 'shadow_ai_logged_in_user',
  SHOW_DATA_COLLECTION_SETTINGS: 'show_data_collection_settings',
  SHOW_VSIX_DOWNLOAD: 'show_vsix_download',
  SIEM_INTEGRATION: 'siem_integration',
  SLACK_SCAN_LOGS_EVENTS: 'slack_scan_logs_events',
  SSO_LOGIN: 'okta_sso_login',
  DATATABLE_LOCAL_PREFERENCES: 'datatable_local_preferences',
  DATATABLE_URL_STATE: 'datatable_url_state',
  EDIT_POLICY_FROM_ALERTS: 'edit_policy_from_alerts',
} as const;

export type FlagsmithFeatureFlag =
  (typeof flagsmithFeatureFlags)[keyof typeof flagsmithFeatureFlags];
